/**
 * `auth` namespace — English canonical source.
 *
 * Owned by the Auth team: the single email-code login / owner-claim flow on
 * `routes/login.tsx`. This copy is SAFETY-RELEVANT — the one-time code, its 10-min
 * expiry, and the "unclaimed instance → first verified email becomes sole owner"
 * semantics must survive translation exactly; do not soften or drop them. Keys are
 * dot-free camelCase; `ko/auth.ts` mirrors this shape (a missing key is a type
 * error). `{email}` is interpolated at the call site.
 */
export const auth = {
  // ── console chrome ──
  tradingConsole: "trading console",

  // ── panel eyebrow + heading (claim vs sign-in are auto-detected) ──
  ownerAccess: "Owner access",
  firstRun: "First run",
  signIn: "Sign in",
  claimTitle: "Claim this instance",
  claimButton: "Claim instance",
  signInSubtitle: "Enter the owner email to receive a one-time code.",
  claimSubtitle: "This instance is unclaimed. The first verified email becomes the sole owner.",

  // ── step 1 · request code ──
  emailLabel: "Email",
  emailPlaceholder: "you@example.com",
  requestCodeError: "Could not send a code. Check the address and try again.",
  sendCode: "Send code",

  // ── step 2 · verify code (email rendered inline between prefix + suffix) ──
  codeSentPrefix: "A code was sent to",
  codeSentSuffix: "if it is eligible. It expires in 10 minutes.",
  verificationCodeLabel: "Verification code",
  codePlaceholder: "000000",
  verifyError: "That code is invalid, expired, or already used.",
  useDifferentEmail: "Use a different email",

  // ── submit-in-flight + safety hero ──
  working: "Working…",
  shipsDisarmed:
    "Ships disarmed. No live orders are placed until you connect a broker and explicitly arm trading in Settings.",
} as const;

export type AuthKey = keyof typeof auth;
